// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutHub_wrapper__vPagP","title":"CheckoutHub_title__BuCSi","wrapperPayment":"CheckoutHub_wrapperPayment__WtKjQ","backToShop":"CheckoutHub_backToShop__sRUGC"};